import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { LocationsSelectFormField } from "Components/Shared/FormComponents/LocationsSelectFormField/LocationsSelectFormField";
import { OperatingManagerFormFields } from "Shared/types/OperatingManager";
import { Option } from "Shared/types/Option";

export interface LocationsFieldProps {
  assignedLocations?: Option[];
  disabled?: boolean;
}

export const LocationsField = ({
  assignedLocations,
  disabled
}: LocationsFieldProps) => {
  const { setValue } = useFormContext<OperatingManagerFormFields>();

  useEffect(() => {
    setValue("locations", assignedLocations);
  }, [assignedLocations, setValue]);

  return (
    <LocationsSelectFormField
      setLocationsFieldValue={locations => setValue("locations", locations)}
      defaultLocations={assignedLocations}
      disabled={disabled}
    />
  );
};
